import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "tasks",
    initialState: [],
    reducers: {
        set: (state, action) => action.payload,
    },
});
